export default __webpack_public_path__ + "static/media/step-h5-bg.0d002c22.png";